import { QuickPayStatusEnum } from "../types/QuickPayRequest";

export const currentQuickPayStatus = (
  status: QuickPayStatusEnum,
  quickPayStatus: QuickPayStatusEnum,
): boolean => status === quickPayStatus;
